import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useDeleteEasyCard from './hooks/useDeleteEasyCard';

declare module '@stackflow/config' {
    interface Register {
        EasyCardDeleteModal: {
            cardId: string;
        }
    }
}

const EasyCardDeleteModal: ActivityComponentType<'EasyCardDeleteModal'> = ({ params }) => {
    const { cardId } = params;
    const { t } = useTranslation('easyCard');
    const { handleDeleteCard } = useDeleteEasyCard(cardId);
    return (
        <AppModal title={t('delete.title')}
            confirm={t('delete.confirm')}
            onConfirm={handleDeleteCard}
            deny={t('delete.cancel')} >
            <Text align='center' size='title'>
                {t('delete.description')}
            </Text>
        </AppModal>
    );
};

export default EasyCardDeleteModal;
